import React, {memo} from 'react';

function ProjectRow(props: {
                      title: string,
                      authors: string,
                      venue: string | null,
                      //titleLink: string | null,
                      otherLinks: any | null,
                      projType: string,
                      projImg: string,
                      projImgAlt: string}) {
  let projLinks = [];
  for (let linkName in props.otherLinks) {
    projLinks.push(<a href={props.otherLinks[linkName]} target="_blank" rel="noreferrer" tabIndex={0}>{linkName}</a>)
  }
  return (
    <tr className="project-row">
      <td>
        <img src={process.env.PUBLIC_URL + "/project_imgs/" + props.projImg} alt={props.projImgAlt}></img>
      </td>
      {/*<td>{props.projType}</td>*/}
      <td>{props.venue}</td>
      {/*<a href={props.titleLink} target="_blank" rel="noreferrer">
        <td>
          <div dangerouslySetInnerHTML={{__html: props.title}}></div>
        </td>
      </a>*/}
      <td>
        <div dangerouslySetInnerHTML={{__html: props.title}}></div>
      </td>
      <td>
        <div dangerouslySetInnerHTML={{__html: props.authors}}></div>
      </td>
      <td>
        <div className="proj-links">
          {projLinks}
        </div>
      </td>
    </tr>
  );
}

export default memo(ProjectRow);